import React from 'react';

import { Block } from '../common/Block.jsx';
import { Carousel } from '../common/Carousel.jsx';
import Defaults from '../layout/Defaults.jsx';
import Kit from '../layout/Kit.jsx';
import LocalStorage from '../common/LocalStorage.jsx';
import Name from '../common/Name.jsx';
import * as RecentlyViewedCell from './RecentlyViewedCell.jsx';
import Utilities from '../common/Utilities.jsx';

let _RecentlyViewedComponentInst;
function RecentlyViewedComponent(props) {
    const [id, setId] = React.useState(undefined);
    React.useEffect(() => setId(Utilities.generateUniqueId()), []);

    const [data, setData] = React.useState(undefined);
    React.useEffect(() => {
        _RecentlyViewedComponentInst = true;
        if (props.builder || props.disabled) {
            if (!props.handlerUrl) {
                setData([]);
                return;
            }
            $.get(`${props.handlerUrl}/api/inventory`, { limit: 8, offset: 0, order: 0, sub: props.config && props.config.subdomain, status: 1, type: 'All' }, (responseData) => {
                if (!_RecentlyViewedComponentInst) {
                    return;
                }
                setData(responseData.inventory || []);
            })
        } else {
            setData(LocalStorage.RecentlyViewed.get());
        }
        return () => _RecentlyViewedComponentInst = undefined
    }, []);
    React.useEffect(() => {
        if (props.builder || !id) {
            return;
        }
        LocalStorage.RecentlyViewed.addListener(`recentlyViewed-${id}`, setData);
        return () => LocalStorage.RecentlyViewed.removeListener(`recentlyViewed-${id}`);
    }, [id]);

    if (!id) {
        return null;
    }
    const blockConfig = props.blockConfig || {};
    if (!blockConfig.block) {
        blockConfig.block = {};
    }
    if (!blockConfig.block.itemSpacing) {
        blockConfig.block.itemSpacing = { 'unit': 'px', 'value': '0' };
    }
    let title;
    const titleStyle = {};
    Block.mapStyleConfigProps(titleStyle, blockConfig.title, (propName, propValue) => {
        switch (propName) {
            case 'title':
                if (!Utilities.isHTMLContentEmpty(propValue)) {
                    title = propValue;
                }
                return true;
        }
    })
    if (title && title.length > 0) {
        title = <div className="richText tabs__title" style={titleStyle}><div dangerouslySetInnerHTML={{ __html: title }} /></div>
    }
    if (blockConfig.layout && blockConfig.layout.maxWidth && blockConfig.layout.maxWidth.value && blockConfig.layout.maxWidth.value.length > 0) {
        const style = Block.updateAlignment({ maxWidth: `${blockConfig.layout.maxWidth.value}${blockConfig.layout.maxWidth.unit}` }, blockConfig.layout.textAlign);
        title = <div style={style}>{title}</div>
    }
    if (!props.builder && data && data.length == 0) {
        return null;
    } else if (data) {
        blockConfig.block.items = Math.min(4, data.length);
    }
    let style;
    if (props.disabled) {
        style = { pointerEvents: 'none' };
    }
    return (
        <Carousel.Component
            {...props}
            blockConfig={blockConfig}
            className="recently__viewed--slider"
            contentConfig={Defaults.cellDesign(props.config, props.blockConfig, Kit.Context.Cell.RecentlyViewed)}
            data={data}
            emptyMessage={data == undefined ? "Loading..." : "You must have at least one inventory shown on your website to configure the Recently Viewed block."}
            slideComponent={RecentlyViewedCell.RecentlyViewedCellContainer}
            style={style}
            title={title} />
    )
}

export default { Component: RecentlyViewedComponent };